import React from "react";
import LanguageSettingsContent from "./LanguageSettingsContent";

const LanguageSettings = ({ state, dispatch }) => (
	<LanguageSettingsContent state={state} dispatch={dispatch} />
);

export default LanguageSettings;
